import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/joy";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";
import { Util } from "../Helpers/Util";
import ContactsDialog from "../Dialogs/ContactsDialog";
import PortalTableLayout from "../components/PortalTableLayout";

interface ContactsListingProps {
	buildingId: string;
}

interface Contact {
	contacts_id: string;
	buildings_id: string;
	date_entered: string;
	email: string;
	first_name: string;
	is_primary: boolean;
	last_name: string;
	phone_number: string;
	send_arrival_texts: boolean;
	send_callback_texts: boolean;
	send_maint_texts: boolean;
	send_nuisance_texts: boolean;
	send_repair_texts: boolean;
	send_sale_texts: boolean;
	send_violation_texts: boolean;
}

export default function ContactsListing(props: ContactsListingProps) {
	const [contacts, setContacts] = React.useState([] as Array<Contact>);
	const [cId, setCid] = React.useState("");
	const [dialog, setDialog] = React.useState(false);

	React.useEffect(() => {
		getData();
	}, [props.buildingId]);

	const getData = () => {
		fetch("Building/GetContacts", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ buildingsId: props.buildingId }),
		})
			.then((x) => x.json())
			.then((x) => setContacts(x as Array<Contact>));
	};
	return (
		<>
			{dialog && (
				<ContactsDialog
					buildingsId={props.buildingId}
					contactsId={cId}
					close={() => {
						getData();
						setDialog(false);
					}}
				/>
			)}
			<PortalTableLayout
				fillHeight={false}
				toolbar={
					<Button
						sx={{ mt: 1 }}
						startDecorator={<AddIcon />}
						onClick={() => {
							setCid("");
							setDialog(true);
						}}>
						Add Contact
					</Button>
				}>
				<Table stickyHeader size="small">
					<TableHead>
						<TableRow>
							<TableCell>First Name</TableCell>
							<TableCell>Last Name</TableCell>
							<TableCell>Phone Number</TableCell>
							<TableCell>Email</TableCell>
							<TableCell>Primary?</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{contacts.map((x) => (
							<TableRow
								key={x.contacts_id}
								hover
								sx={{ cursor: "pointer" }}
								onClick={() => {
									setCid(x.contacts_id);
									setDialog(true);
								}}>
								<TableCell>{x.first_name}</TableCell>
								<TableCell>{x.last_name}</TableCell>
								<TableCell>{x.phone_number}</TableCell>
								<TableCell>{x.email}</TableCell>
								<TableCell>{Util.Formatter(x.is_primary, "L")}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</PortalTableLayout>
		</>
	);
}
